import { render, staticRenderFns } from "./HsCodeSearchPop.vue?vue&type=template&id=22cc56d3&scoped=true"
import script from "./HsCodeSearchPop.vue?vue&type=script&lang=js"
export * from "./HsCodeSearchPop.vue?vue&type=script&lang=js"
import style0 from "./HsCodeSearchPop.vue?vue&type=style&index=0&id=22cc56d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc56d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cc56d3')) {
      api.createRecord('22cc56d3', component.options)
    } else {
      api.reload('22cc56d3', component.options)
    }
    module.hot.accept("./HsCodeSearchPop.vue?vue&type=template&id=22cc56d3&scoped=true", function () {
      api.rerender('22cc56d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/HsCodeSearchPop.vue"
export default component.exports